<template lang="pug">
  v-flex
    v-form(v-model='formulario_validado' autocomplete='false')
      v-layout.row.wrap(v-if='!Datos.isClose || !Datos.isAnnulled')
        v-layout.row.wrap
          v-autocomplete(label='Tipo nota crédito')
          v-spacer
          v-text-field(label='Documento' disabled)
          v-spacer
          v-text-field(label='Importe' disabled)
          v-spacer
          v-form
            v-checkbox(label='Aplicar')
          v-spacer
          v-dialog(v-model='dialog' width='800')
            template(v-slot:activator='{ on }')
              v-btn(color='primary' v-on='on' @click='cleanSelectedKey()') Ver referencias
            v-card
                v-form(autocomplete='false')
                    v-card-title.headline.grey.lighten-2(primary-title) 
                    v-layout.align-items-end
                        span.pb-3 Referencia
                    v-spacer
                    v-container(fluid)
                    v-layout.row.wrap
                        v-flex.xs4.p-1
                        template(v-slot:activator='{ on }')
                            v-text-field(type= 'date' label='Filtrar por fecha')
                   
                    v-spacer
                        v-data-table( :headers="headersDocument" :items="Datos.items" )
</template>
<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
export default {
  data: ()=>({
    search: '',
    dialog: false,
    headersDocument: [
      { text: 'Sol', value: '',  sortable: false   },
      { text: 'Documento',  value: '' },
      { text: 'Fecha', value: ''},
      { text: 'Nombre/Razón Social',     value: ''},
      { text: 'Glosa',  value: 'total'},
    ],

    itemToAdd: {},
    datePicker: false,
    formulario_validado: true,
  }),

  methods:{
    ...mapActions({ 
      add: 'Sales/add',
      annul: 'Sales/annul',
      cleanSelectedKey: 'Sales/clearForm',

    }),  
  },
  computed:{
    ...mapGetters({
      productsRecord: 'Product/record',
      documentRecord: 'Documents/inputDocumentsRecord',
      kardex: 'Kardex/getKardex',
      supplierRecord: 'Suppliers/record',
      InputMotivesRecord: 'Operations/inputRecord',
    }),
    ...mapState({
      Datos: state=>state.Sales.data,
      Ventas: state=>state.Sales,

    })
  },
}
</script>

